import { render, staticRenderFns } from "./dropshippingSignup.vue?vue&type=template&id=27eca44c"
import script from "./dropshippingSignup.vue?vue&type=script&lang=js"
export * from "./dropshippingSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLink: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/22072026_100728/resources/assets/marketplace/components/BaseLink.vue').default})
